export default {
  Account: `Účet`,
  Features: `Vlastnosti`,
  Pricing: `Ceník`,
  FAQ: `Často kladené dotazy`,
  Contact: `Kontakt`,
  "Log in": `Přihlásit se`,
  "UNITED BANKING": `UNITED <br>BANKING`,
  "Connect your partners into unified ecosystem for rapid and secure fund flows": `Spojte své partnery do jednotného ekosystému <br />pro rychlý a bezpečný tok finančních prostředků`,
  header: {
    "Sign Up": `Zaregistrovat se`,
  },
  account: {
    "PERSONAL AND BUSINESS ACCOUNT": `OSOBNÍ<br />A FIREMNÍ<br> ÚČET`,
    "Manage all your financial transactions": `Spravujte všechny své finanční transakce,<br> provádějte a přijímejte platby.<br> Vše na jednom místě.`,
    "Create Account": `Vytvořit účet`,
    Fast: `Rychle`,
    Simple: `Snadno`,
    Global: `Globálné`,
    "Fast online application and onboarding": `Rychlá online žádost a registrace`,
    "Execute all banking tasks at lightspeed": `Provádějte všechny bankovní úkoly bleskovou rychlostí`,
    "SEPA & SWIFT for easy fund transfers globally": `SEPA & SWIFT pro snadné převody peněz po celém světě`,
    "Crypto payments and investments": `Krypto platby a investice`,
    "Personalized support available anytime": `Personalizovaná podpora k dispozici kdykoliv`,
    "TOP-TIER SECURITY": `NEJVYŠŠÍ ÚROVEŇ ZABEZPEČENÍ`,
    Trust: `Důvěřujte našim špičkovým bezpečnostním protokolům, které vám poskytnou klid, abyste se mohli s jistotou věnovat správě svých financí.`,
    "SMOOTH TRANSACTIONS": `HLADKÉ TRANSAKCE`,
    "INTEGRATED ECOSYSTEM": `INTEGROVANÝ EKOSYSTÉM`,
    "Our platform": `Naše platforma propojuje všechny vaše partnery, zaměstnance a dodavatele do jednotného centra. Zažijte bezproblémovou spolupráci a zefektivněnou komunikaci napříč celou vaší sítí.`,
    Experience: `Zažijte bezproblémové a efektivní transakce jako nikdy předtím. Naše platforma zajišťuje, že každá platba a bankovní úkol jsou zpracovány rychle, bezpečně a bez obtíží.`,
  },
  features: {
    "UNITY AT THE CORE": `JEDNOTA V JÁDRU`,
  },
  EXPLORE: `PROZKOUMAT`,
  "EXPLORE A COMPLETE FINANCIAL PLATFORM POWERED BY BANK ACCOUNT": `PROZKOUMEJTE KOMPLETNÍ FINANČNÍ PLATFORMU POHÁNĚNOU BANKOVNÍM ÚČTEM`,
  pricing: {
    "ON REQUEST": `NA ZNAMENÍ`,
    PRICING: `CENÍK`,
    "EXPLORE OUR PRICING": `PROZKOUMEJTE NÁŠ CENÍK`,
    BUSINESS: `FIREMNÍ`,
    PERSONAL: `OSOBNÍ`,
    "PRIVATE INDIVIDUALS": `SOUKROMÉ OSOBY`,
    "Contact Sales": `Kontaktovat prodej`,
    "Handling of documents and opening a customer account": `Zpracování dokumentů a otevření zákaznického účtu`,
    "Account monthly service fee": `Měsíční poplatek za vedení účtu`,
    "Incoming internal payment": `Příchozí vnitřní platba`,
    "Incoming SEPA-payment": `Příchozí SEPA platba`,
    "Incoming SWIFT-payment": `Příchozí SWIFT platba`,
    "Internal outgoing payment between own accounts with in Swipez": `Odchozí vnitřní platba mezi vlastními účty v rámci Swipez`,
    "Internal outgoing payment with in Swipez": `Odchozí vnitřní platba v rámci Swipez`,
    "Internal outgoing payment": `Odchozí vnitřní platba`,
    "Outgoing SEPA-payment": `Odchozí SEPA platba`,
    "Outgoing SWIFT-paymen": `Odchozí SWIFT platba`,
    "Opening a customer account": `Otevření zákaznického účtu`,
    "Withdrawal to card": `Výběr na kartu`,
    "Payment card top-up": `Dobití platební karty`,
    "Free of change": `Zdarma`,
  },
  faq: {
    FAQ: `FAQ`,
  },
  questtions: {
    "FREQUENTLY ASKED QUESTIONS": `ČASTO<br>KLADENÉ OTÁZKY`,
    "Swipez company is registered in the Czech Republic": `Společnost Swipez je registrovaná v České republice`,
    "What country is Swipez registered at?": `V jaké zemi je Swipez registrován?`,
    "We use technologies that guarantee secure online payments and two-factor authentication": `Používáme technologie, které zaručují bezpečné online platby a dvoufaktorovou autentizaci. Uživatelé navíc dostávají v reálném čase oznámení o všech transakcích na účtu.`,
    "Funds of our customers are kept in a separate account in the Czech bank": `Prostředky našich zákazníků jsou vedeny na samostatném účtu v české bance a nemůže s nimi nikdo kromě zákazníka nakládat, tedy jsou 100% chráněny.`,
    "When opening an account, a passport or ID card is required": `Při otevření účtu je vyžadován pas nebo občanský průkaz a také účet za energie nebo výpis z účtu s vaším jménem a adresou.`,
    "You will get access as soon as your identity is checked and verified": `Přístup získáte, jakmile bude zkontrolována a ověřena vaše identita. Obvykle to trvá od 30 minut do několika hodin.`,
    "Currently, an account may be opened": `V současné době lze účet otevřít, pokud je vám více než 18 let a nejste rezidentem následujících zemí: Afghánistán, Albánie, Alžírsko, Středoafrická republika, Čína, Kuba, Demokratická republika Kongo, Ekvádor, Guyana, Indonésie, Indie, Írán, Irák, Pobřeží slonoviny, Nigérie, Severní Korea, Laos, Panama, Papua Nová Guinea, Rusko, Súdán, Sýrie, Uganda, Jemen, Zimbabwe..`,
    "How safe is Swipez service?": `Jak bezpečná je služba Swipez?`,
    "How safe is it to keep money at Swipez?": `Jak bezpečné je držet peníze na Swipez?`,
    "What documents must be presented for opening an account?": `Jaké dokumenty je nutné předložit pro otevření účtu?`,
    "When will I get access to the online bank?": `Kdy získám přístup k online bankovnictví?`,
    "Residents of what countries may not open an account?": `Obyvatelé kterých zemí nemohou otevřít účet?`,
  },
  footer: {
    "NEED OUR TEAM HELP?": `POTŘEBUJETE POMOC<br> NAŠEHO TÝMU?`,
    "Privacy Policy": `Zásady ochrany osobních údajů`,
    "Terms and Conditions": `Obchodní podmínky`,
    "Claims Procedure": `Postup při reklamaci`,
    "Cryptocurrency Exchange Notice": `Upozornění na směnu kryptoměn`,
    desk0: `Chcete-li zjistit, která společnost Revolut vás obsluhuje nebo máte-li jakékoli dotazy, kontaktujte nás prostřednictvím chatu v aplikaci.`,
    desk1: `Revolut Ltd je registrována v Anglii a Walesu (č. 08804411), 7 Westferry Circus, Canary Wharf, Londýn, Anglie, E14 4HD a je autorizována Financial Conduct Authority podle Electronic Money Regulations 2011 (referenční číslo 900562). Revolut Travel Ltd je autorizována Financial Conduct Authority k provádění distribuce pojištění (č. FCA: 780586). Naše pojišťovací produkty jsou zajišťovány Revolut Travel Ltd a Revolut Ltd, která je jmenovaným zástupcem Revolut Travel Ltd. Produkty obchodování s akciemi společnosti Revolut poskytuje Revolut Trading Ltd (č. 832790), jmenovaný zástupce Resolution Compliance Ltd, která je autorizována a regulována Financial Conduct Authority.`,
    desk2: `Revolut Ltd je také registrována u Financial Conduct Authority k poskytování služeb s kryptoměnami podle Money Laundering, Terrorist Financing and Transfer of Funds (Information on the Payer) Regulations 2017. Služby s drahými kovy jsou poskytovány Revolut Ltd a nejsou regulovány Financial Conduct Authority.`,
    "Complaints Disclaimer": `Vyloučení reklamace`,
    "Safeguarding Disclaimer": `Zajištění vyloučení odpovědnosti`,
    "All rights reserved": `Všechna práva vyhrazena. Všechny ostatní ochranné známky, názvy produktů a loga zde uvedené nebo zmíněné jsou majetkem příslušných vlastníků. Při používání této webové stránky a/nebo našich služeb souhlasíte s tím, že jste si pozorně přečetli, přijali a stali se právně vázáni Smluvními podmínkami, Reklamačními podmínkami, Zásadami ochrany osobních údajů. Provozovatelem těchto webových stránek je Draph Solutions sro, se sídlem Národní 961/25, Staré Město, 110 00 Praha 1, Česká republika, finanční instituce se sídlem v ČR, licencovaná a regulovaná Českou národní bankou, oprávněná k poskytování osobních a podnikatelských běžných účtů a k poskytování tuzemského a mezinárodního platebního styku. Licence udělená Českou národní bankou podle zákona č. 370/2017 Sb. Zákon o platebních službách.`,
  },
  Call: `Telefon`,
  Email: `E-mail`,
  "Back to website": `Zpět na webovou stránku`,
  privacyPolicy: {
    Privacy: `Ochrana osobních údajů`,
    Policy: `Politika`,
  },
  terms: {
    Terms: `Obchodni`,
    And: `podminky`,
    Conditions: ``,
  },
  complaints: {
    complaints: `Vyloučeni `,
    disclaimer: `reklamace`,
  },
  safeguarding: {
    safeguarding: `Zajišteni vyloučeni`,
    disclaimer: `odpovednosti`,
  },
};
